import { createSelector } from '@reduxjs/toolkit';

export const getFooter = ()=> {
    return createSelector(
        (state) => state.footer_news,
        (state) => state
    )
}